export const PAIS = 'P';
export const PROVINCIA = 'R';
export const LOCALIDAD = 'L';
